"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _List = _interopRequireDefault(require("./styles/List"));
var _excluded = ["className", "shouldWrap", "columns", "children"];
var List = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var className = _ref.className,
    shouldWrap = _ref.shouldWrap,
    columns = _ref.columns,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var isColumn = !!columns;
  var wrapIt = isColumn && columns !== 1 || shouldWrap;
  var columnClass = "list--columns_".concat(columns);
  return /*#__PURE__*/_react["default"].createElement("ul", (0, _extends2["default"])({
    ref: ref,
    className: (0, _classnames["default"])('list', (0, _defineProperty2["default"])((0, _defineProperty2["default"])({
      'list--column': isColumn
    }, columnClass, isColumn), 'list--wrap', wrapIt), _List["default"].list, isColumn && _List["default"].list_column, isColumn && _List["default"][columnClass], wrapIt && _List["default"].list_wrap, className)
  }, props), children);
});
List.displayName = 'List';
var _default = exports["default"] = List;